import adventureActivities from './amenity-modules/adventure-activities.json';
import allInclusiveInclusionsActivitiesAndRecreation from './amenity-modules/all-inclusive-inclusions-activities-and-recreation.json';
import allInclusiveRestrictionsActivitiesAndRecreation from './amenity-modules/all-inclusive-restrictions-activities-and-recreation.json';
import casinoAndGaming from './amenity-modules/casino-and-gaming.json';
import fitness from './amenity-modules/fitness.json';
import golf from './amenity-modules/golf.json';
import hotSprings from './amenity-modules/hot-springs.json';
import pools from './amenity-modules/pools.json';
import shopping from './amenity-modules/shopping.json';
import skiingSnowboarding from './amenity-modules/skiing-snowboarding.json';
import spa from './amenity-modules/spa.json';
import sports from './amenity-modules/sports.json';
import waterBasedActivities from './amenity-modules/water-based-activities.json';
import winery from './amenity-modules/winery.json';
import accessibility from './amenity-modules/accessibility.json';
import transportation from './amenity-modules/transportation.json';
import allInclusiveInclusionsFoodAndBeverage from './amenity-modules/all-inclusive-inclusions-food-and-beverage.json';
import allInclusiveInclusionServicesAndFacilities from './amenity-modules/all-inclusive-inclusions-services-and-facilities.json';
import allInclusiveRestrictionsFoodAndBeverage from './amenity-modules/all-inclusive-restrictions-food-and-beverage.json';
import beach from './amenity-modules/beach.json';
import breakfast from './amenity-modules/breakfast.json';
import buildingFeatures from './amenity-modules/building-features.json';
import business from './amenity-modules/business.json';
import checkInOut from './amenity-modules/check-in-out.json';
import cityHighlights from './amenity-modules/city-highlights.json';
import dining from './amenity-modules/dining.json';
import gamesAndEntertainment from './amenity-modules/games-and-entertainment.json';
import mandatoryFeesFacilitiesAndServices from './amenity-modules/mandatory-fees-facilities-and-services.json';
import familyAndChildren from './amenity-modules/family-and-children.json';
import guestServices from './amenity-modules/guest-services.json';
import internet from './amenity-modules/internet.json';
import languages from './amenity-modules/languages.json';
import natureHighlights from './amenity-modules/nature-highlights.json';
import outdoorAreas from './amenity-modules/outdoor-areas.json';
import parking from './amenity-modules/parking.json';
import pets from './amenity-modules/pets.json';
import mandatoryFeesResortFee from './amenity-modules/mandatory-fees-resort-fee.json';
import romantic from './amenity-modules/romantic.json';
import ryokan from './amenity-modules/ryokan.json';
import safariAndGame from './amenity-modules/safari-and-game.json';
import transportationAndShuttles from './amenity-modules/transportation-and-shuttles.json';

import carterTo from './amenity-modules/carter-to.json';
import optionalFeesOfDeposits from './amenity-modules/optional-fees-of-deposits.json';
import otherPolicies from './amenity-modules/other-policies.json';
import paymentMethods from './amenity-modules/payment-methods.json';
import mandatoryFeesTaxes from './amenity-modules/mandatory-fees-taxes.json';
import travelerSafety from './amenity-modules/traveler-safety.json';
import renovation from './amenity-modules/renovation.json';
import closures from './amenity-modules/closures.json';
import covid from './amenity-modules/covid.json';

export const PROPERTY_AMENITY_GROUPS = [
  {
    value: 'activitiesOnOffer',
    name: 'AMENITIES.ACTIVITIES_ON_OFFER',
    modules: [
      adventureActivities,
      allInclusiveInclusionsActivitiesAndRecreation,
      allInclusiveRestrictionsActivitiesAndRecreation,
      casinoAndGaming,
      fitness,
      golf,
      hotSprings,
      pools,
      shopping,
      skiingSnowboarding,
      spa,
      sports,
      waterBasedActivities,
      winery,
    ],
  },
  {
    value: 'facilitiesAndServices',
    name: 'AMENITIES.FACILITIES_AND_SERVICES',
    modules: [
      accessibility,
      transportation,
      allInclusiveInclusionsFoodAndBeverage,
      allInclusiveInclusionServicesAndFacilities,
      allInclusiveRestrictionsFoodAndBeverage,
      beach,
      breakfast,
      buildingFeatures,
      business,
      checkInOut,
      cityHighlights,
      dining,
      gamesAndEntertainment,
      mandatoryFeesFacilitiesAndServices,
      familyAndChildren,
      guestServices,
      internet,
      languages,
      natureHighlights,
      outdoorAreas,
      parking,
      pets,
      mandatoryFeesResortFee,
      romantic,
      ryokan,
      safariAndGame,
      transportationAndShuttles,
    ],
  },
  {
    value: 'policiesAndDeposits',
    name: 'AMENITIES.POLICIES_AND_DEPOSITS',
    modules: [carterTo, optionalFeesOfDeposits, otherPolicies, paymentMethods, mandatoryFeesTaxes, travelerSafety],
  },
  {
    value: 'renovationAndClosures',
    name: 'AMENITIES.RENOVATION_AND_CLOSURES',
    modules: [renovation, closures],
  },
  {
    value: 'health',
    name: 'AMENITIES.COVID19',
    modules: [covid],
  },
];
